module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(this.isSetString(_vm.gameInfo['landing_page'])) ? _c('van-row', {
    staticClass: "banner-panel"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['landing_page']
    }
  })]) : _vm._e(), _vm._v(" "), _c('van-row', {
    staticClass: "icon-panel"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['game_icon']
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('van-row', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.gameInfo['game_name']))]), _vm._v(" "), _c('van-row', {
    staticClass: "tag"
  }, [(this.isSetString(_vm.gameInfo['tag_one'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tag_one']))]) : _vm._e(), _vm._v(" "), (this.isSetString(_vm.gameInfo['tag_two'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tag_two']))]) : _vm._e(), _vm._v(" "), (this.isSetString(_vm.gameInfo['tag_three'])) ? _c('span', [_vm._v(_vm._s(_vm.gameInfo['tag_three']))]) : _vm._e()]), _vm._v(" "), _c('van-row', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.gameInfo['downloads']))]), _vm._v("人在玩")]), _vm._v(" "), _c('van-row', {
    staticClass: "btns"
  }, [(this.isSetString(_vm.gameInfo['isH5'])) ? _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.playH5Game();
      }
    }
  }, [_vm._v("开始游戏")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item download",
    on: {
      "click": function($event) {
        return _vm.downloadGame();
      }
    }
  }, [_vm._v("下载游戏")])])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "game-about"
  }, [_c('van-row', {
    staticClass: "title"
  }, [_vm._v("游戏简介")]), _vm._v(" "), _c('van-row', {
    class: ['content', _vm.isMore && 'show']
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.gameInfo['describe'])
    }
  }), _vm._v(" "), (!_vm.isMore) ? _c('div', {
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }, [_c('span', [_vm._v("...")]), _vm._v("更多")]) : _vm._e()]), _vm._v(" "), _c('van-row', {
    staticClass: "pic-view"
  }, _vm._l((_vm.gameInfo['screenshot']), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handlePreview(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.entityFileMain + '/' + item
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "footer-panel"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.entityFileMain + '/' + _vm.gameInfo['game_icon']
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.gameInfo['game_name']))]), _vm._v(" "), _c('van-col', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "download",
    on: {
      "click": function($event) {
        return _vm.downloadGame()
      }
    }
  }, [_vm._v("下载游戏")])])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '35%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_c('div', {
    staticClass: "toast-top"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('div', {
    staticClass: "toast-middle"
  }, [_vm._v("亲爱的少侠，在安装游戏时 请选择")]), _vm._v(" "), _c('div', {
    staticClass: "toast-bottom"
  }, [_c('span', {}, [_vm._v("\"继续安装\"")]), _vm._v(" (不要选择\"去手机应用市场查找\")")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleClickKnow
    }
  }, [_vm._v("我知道了")])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "用户中心",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.isRegister),
      callback: function($$v) {
        _vm.isRegister = $$v
      },
      expression: "isRegister"
    }
  }, [_c('div', {
    staticClass: "form-close",
    on: {
      "click": function($event) {
        _vm.isLogin = _vm.isRegister = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/close.png")
    }
  })]), _vm._v(" "), _c('van-row', {
    staticClass: "form-register"
  }, [_c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/accout.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    attrs: {
      "placeholder": "字母开头，5-16位数字或字母"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rePassword),
      expression: "form.rePassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重新输入密码"
    },
    domProps: {
      "value": (_vm.form.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rePassword", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "form-button"
  }, [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleConfirm(1)
      }
    }
  }, [_vm._v("立即注册")])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "other-tips"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openUserDialog(1)
      }
    }
  }, [_vm._v("用户登录")])])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "用户中心",
      "show-confirm-button": false
    },
    model: {
      value: (_vm.isLogin),
      callback: function($$v) {
        _vm.isLogin = $$v
      },
      expression: "isLogin"
    }
  }, [_c('div', {
    staticClass: "form-close",
    on: {
      "click": function($event) {
        _vm.isLogin = _vm.isRegister = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/close.png")
    }
  })]), _vm._v(" "), _c('van-row', {
    staticClass: "form-register"
  }, [_c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/accout.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    attrs: {
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "item"
  }, [_c('van-col', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon/password.png")
    }
  })]), _vm._v(" "), _c('van-col', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('van-row', {
    staticClass: "form-button"
  }, [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleConfirm(2)
      }
    }
  }, [_vm._v("立即登录")])], 1), _vm._v(" "), _c('van-row', {
    staticClass: "other-tips"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openUserDialog(2)
      }
    }
  }, [_vm._v("用户注册")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlistTips),
      expression: "showPlistTips"
    }],
    staticClass: "plist-container"
  }, [_c('img', {
    staticClass: "wx_flow_img",
    attrs: {
      "src": require("../../assets/images/plist_wx_flow.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWXTips),
      expression: "showWXTips"
    }],
    staticClass: "wx-tips-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/wx_tips.jpg")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb85514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LandingPage/game.vue
// module id = 400
// module chunks = 11